var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBitbucket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 29 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1868DB",
  d: "m27.328 11.597-2.161 13.14c-.141.795-.705 1.263-1.504 1.263H5.337c-.799 0-1.363-.468-1.504-1.263L.027 1.31C-.114.514.309 0 1.06 0h26.878c.752 0 1.175.514 1.034 1.31L27.94 7.481c-.14.889-.657 1.263-1.503 1.263H10.27c-.235 0-.376.14-.33.42l1.27 7.763c.047.187.188.327.375.327h5.827c.188 0 .33-.14.376-.327l.893-5.611c.094-.702.564-.982 1.222-.982h6.344c.94 0 1.221.467 1.08 1.262"
})));
export default SvgBitbucket;